import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICase, ICaseState } from 'entities/insurance-contract/main-info/types/MainInfo-interface';
import { fetchCase } from 'entities/insurance-contract/main-info/actions/fetch-main-info';

export const initialCaseState = {
    Number: "",
    StartDate: "",
    EndDate: "",
    InsurerName: "",
    HoldingName: "",
    InsurancePremium: "",
    InsuranceSum: "",
    InsuredQuantity: "",
    DoctorCurator: {
        Name: "",
        Email: "",
        WorkPhone: "",
        MobilePhone: "",
    },
    AdminCurator: {
        Name: "",
        Email: "",
        WorkPhone: "",
        MobilePhone: "",
    },
    Curators: [],
    HasSpecialProgramData: false
};

const initialState: ICaseState = {
    case: initialCaseState,
    isLoadingCase: false,
    errorCase: [],
    lastFetchTimeCase: null,
    idCase: null,
};

export const contractCase = createSlice({
    name: 'contractCase',
    initialState,
    reducers: {
        resetCaseData: (state) => {
            state.isLoadingCase = false;
            state.case = initialCaseState;
            state.errorCase = [];
            state.lastFetchTimeCase = null;
            state.idCase = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCase.pending, (state) => {
                state.isLoadingCase = true;

            })
            .addCase(fetchCase.fulfilled, (state, action: PayloadAction<{ case: ICase, idCase: string, fetchTime: number }>) => {
                state.isLoadingCase = false;
                state.case = action.payload.case;
                state.errorCase = [];
                state.lastFetchTimeCase = action.payload.fetchTime;
                state.idCase = action.payload.idCase;
            })
            .addCase(fetchCase.rejected, (state, action) => {
                state.case = initialCaseState;
                state.isLoadingCase = false;
                state.lastFetchTimeCase = null;
                state.errorCase = action.payload as string[];
            });
    },
});

export const { resetCaseData } = contractCase.actions;

export default contractCase.reducer;